

$( document ).ready(function() {
 


  setTimeout(function() {

    $('iframe').each(function(index) {
        const iframe = $(this);
        const player = new Vimeo.Player($(this));
        // console.log("gaygkgk");
        player.play().then(function() {
        }).catch(function(error) {
          switch (error.name) {
            case 'PasswordError':
            
                // The video is password-protected
                break;
            case 'PrivacyError':
                // The video is private
                break;
            default:
                // Some other error occurred 
               // console.log("gaygkgk");
                  var val = iframe.attr('src').replace('autoplay=1', 'autoplay=0');
                  iframe.attr('src', val);
                break;
          }
        });

        var unmutebutton = $(this).closest('.unmute');
        var playpausebutton = $(this).closest('.playvideo');

        console.log(unmutebutton);

        unmutebutton.click(function() {
          player.setVolume(1);
          console.log("mute");
        });

   });
  

       
 

        // $(".videocontrols").each(function(index) {
        //   var iframe = $(this).closest('iframe').first();
          
        // //  const player = new Vimeo.Player(iframe[0]);
        //   var unmutebutton = $(this).closest('.unmute');
        //   var playpausebutton = $(this).closest('.playvideo');

        //   //console.log(unmutebutton);

        //   console.log(iframe);
        //   console.log(iframe.first());

        //   unmutebutton.click(function() {
        //     player.setMuted(false);
        //     console.log("mute");
        //   });

        // });


      }, 700);



  setTimeout(() => {

    $('#loader').fadeOut(500);
 
  }, 1500);


    /// Product page ////


    $('.product-information-tab-title').click(function(){
    var tab_id = $(this).attr('data-id');

    $('.product-information-tab-content').removeClass('active');
    $('.product-information-tab-title').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
    });  


    $('.close-sizeguide').click(function(){
    
      $('.product-information-tab-content').removeClass('active');
      $('.product-information-tab-title').removeClass('active');
    
      $('.product-information-tab-content:first-of-type').addClass('active');
      $('.product-information-tab-title:first-of-type').addClass('active');
    
  
    });
    

      if ($(window).width() < 768) {
       
         $('.product__photo').slick({
          // dots: false,
          // arrows: false

          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true


         });

         

     }



    // document.addEventListener('DOMContentLoaded', function () {
    //   // Prepare BackgroundCheck
    //   BackgroundCheck.init({
    //     targets: '.desktop-nav'
    //     });
    // });



    if ( $('body').hasClass('template-index') ){
       $('.menu-shop').addClass('current');
    }

    if ( $("body").is("#information") ) {
      $('.menu-information').addClass('current');
    }

    if ( $('body').hasClass('template-customers-register') || $('body').hasClass('template-login')  ){
      $('.menu-account').addClass('current');
    }


    $('.close-size-chart').on('click', function(e) {
        e.preventDefault();
        $('#size-chart').css("display","none");
        currentScroll=$(window).scrollTop();
        $('body').css('overflow', 'auto');
        $(window).unbind('scroll');
    });  

    $('.showsizechart').on('click', function(e) {
        e.preventDefault();
        $('#size-chart').css("display","block");
      currentScroll=$(window).scrollTop();
        $(window).bind('scroll',lockscroll);
      $('body').css('overflow', 'hidden');
    }); 

    var touch   = $('.site-header__menu');
    var infomobile  = $('.mobile-nav-wrapper');

    $(touch).on('click', function(e) {
        e.preventDefault();
       // touch.toggleClass("open");
        infomobile.toggleClass("open");
       
    });

    $('.product-image-gallery-slider').slick({
      // infinite: true,
      // speed: 300,
      // arrows: true,
      // fade: false, 
      //  slidesToScroll: 2, 
      //  slidesToShow: 3, 
      // variableWidth: true, 
      // prevArrow:'<button class="slick-prev" aria-label="Previous" type="button"></button>',
      // nextArrow:'<button class="slick-next" aria-label="Next" type="button"></button>',

     // dots: true, 
      infinite: true,
      speed: 300,
      slidesToShow: 1,
    // centerMode: true,
      variableWidth: true

    }); 




 

    if( $('body').hasClass('template-index')){

            
      //  gsap.registerPlugin(ScrollTrigger);

        // Using Locomotive Scroll from Locomotive https://github.com/locomotivemtl/locomotive-scroll
        
        // const locoScroll = new LocomotiveScroll({
        //   el: document.querySelector(".smooth-scroll"),
        //   smooth: true,
        //   multiplier : 0.95,
        //   touchMultiplier : 0.2,
        //   smoothMobile: 1,
        //   smartphone: { 
        //       smooth: !1, 
        //       breakpoint: 767
        //   },
        //   tablet: {
        //       smooth: !1,
        //       breakpoint: 1024
        //   }
        
        // });
        // locoScroll.on("scroll", ScrollTrigger.update);
        
        // // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
        // ScrollTrigger.scrollerProxy(".smooth-scroll", {
        //   scrollTop(value) {
        //     return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
        //   }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        //   getBoundingClientRect() {
        //     return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        //   },
        //   pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
        // });
        
       

        // gsap.utils.toArray(".sticky-section").forEach((text, i) => {
        //   gsap.from(text, {
        //       scrollTrigger: {
        //         trigger: text,
        //         scroller: ".smooth-scroll",
        //         scrub: "1",
        //         pin: true,
        //         anticipatePin: "1",
        //         pinSpacing: false,
        //         start: "bottom bottom",  
        //         end: "bottom top"
        //       }
        //     });
        //   });


    }


    $('section').on('contextmenu', 'img', function(e){ 
      return false; 
    });

});


